import Vue from 'vue'
import Vuex from 'vuex'
import activePlay from './activePlay'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    hasAccess: false,
    openTenant: 0,
    tenantId: '',
    userInfo: {}
  },
  mutations: {
    setUser(state, userInfo) {
      state.userInfo = userInfo
    },
    setTenantId(state, payload) {
      state.tenantId = payload
    },
    setOpenTenant(state, payload) {
      state.openTenant = payload
    },
    setHasAccess(state, payload) {
      state.hasAccess = payload
    }
  },
  actions: {},
  modules: {activePlay}
})
